module.exports = __webpack_public_path__ + "media/images/indicators/erosao-2cca4ebac9bd8f4a4b68f2263a0ab8a0.png";